import { render, staticRenderFns } from "./CellRendererWithHoldings.vue?vue&type=template&id=45925c18"
import script from "./CellRendererWithHoldings.vue?vue&type=script&lang=js"
export * from "./CellRendererWithHoldings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports